module.exports = {"350105001":"罗星街道","350105100":"马尾镇","350105101":"亭江镇","350105102":"琅岐镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350105.json
// module id = 1068
// module chunks = 0